export default __webpack_public_path__ + "static/logo3-2fe3b96e715526da7cfafbb182c7309b.svg";